import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';
import { z } from 'zod';

export interface ForgotPasswordData {
  emailAddress: string;
}

// Define schema that matches ForgotPasswordResponse
const forgotPasswordResponseSchema = z.object({
  challenge: z.string().optional(),
  session: z.string().optional(),
  version: z.string().optional(),
  message: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  title: z.string().optional(),
});

// Extract type from schema
export type ForgotPasswordResponse = z.infer<
  typeof forgotPasswordResponseSchema
>;

export default async function fetchForgotPassword(
  lambdaUrl: string,
  data: ForgotPasswordData,
  headers: Headers,
) {
  const response = await unauthenticatedFetch(`${lambdaUrl}/forgot-password`, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(data),
    headers,
  });

  const result: unknown = await response.json();
  return forgotPasswordResponseSchema.parse(result);
}
